function GETING_MODULES(value = []) {
  return { type: "GETING_MODULES", payload: value };
}

export { GETING_MODULES };
